export default function downloadFile(fileName: string, content: Blob): void {
  if (content) {
    const url = window.URL.createObjectURL(content);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    link.setAttribute('target', '_blank');

    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  }
}
